import { render, staticRenderFns } from "./TourTable.vue?vue&type=template&id=22689bea"
import script from "./TourTable.vue?vue&type=script&lang=js"
export * from "./TourTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports